<template>
    <div class="ConnaitreRejoindre">
        <HeadPage :title="'Nous rejoindre'" 
                  :category="'Nous connaitre'"
                  :img="'nous-connaitre/rejoindre.jpg'"
                  :imgAlt="'Rejoindre head page'"
                   class="HeadPage-ConnaitreRejoindre-Image"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "ConnaitreRejoindre",
    data() {
        return {
            content: [
                {  
                    text: [ `Vous souhaitez rejoindre <strong>notre équipe de consultants</strong> ?`,
                    `Envoyez-nous votre candidature : <a href="mailto:contact@jobstream.fr">contact@jobstream.fr</a>`
                ]
                },
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>